import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import ArticlePage from '../pages/article/page';
import AboutPage from '../pages/about/page';
import DisclaimerPage from '../pages/disclaimer/page';
import PrivacyPage from '../pages/privacy/page';
import TermsPage from '../pages/terms/page';

const routes: RouteObject[] = [
  // Root redirect will be handled by component
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/en',
    element: <Home />,
  },
  {
    path: '/en/',
    element: <Home />,
  },
  {
    path: '/pt',
    element: <Home />,
  },
  {
    path: '/pt/',
    element: <Home />,
  },
  {
    path: '/de',
    element: <Home />,
  },
  {
    path: '/de/',
    element: <Home />,
  },
  // Article pages (dynamic slug)
  {
    path: '/:lang/blog/:slug',
    element: <ArticlePage />,
  },
  // Legal pages
  {
    path: '/en/about/',
    element: <AboutPage />,
  },
  {
    path: '/pt/about/',
    element: <AboutPage />,
  },
  {
    path: '/de/about/',
    element: <AboutPage />,
  },
  {
    path: '/en/disclaimer/',
    element: <DisclaimerPage />,
  },
  {
    path: '/pt/disclaimer/',
    element: <DisclaimerPage />,
  },
  {
    path: '/de/disclaimer/',
    element: <DisclaimerPage />,
  },
  {
    path: '/en/privacy/',
    element: <PrivacyPage />,
  },
  {
    path: '/pt/privacy/',
    element: <PrivacyPage />,
  },
  {
    path: '/de/privacy/',
    element: <PrivacyPage />,
  },
  {
    path: '/en/terms/',
    element: <TermsPage />,
  },
  {
    path: '/pt/terms/',
    element: <TermsPage />,
  },
  {
    path: '/de/terms/',
    element: <TermsPage />,
  },
  // Catch all
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;